import React, { useState, useEffect } from "react";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaDollarSign,
  FaExclamationTriangle,
  FaClipboardList,
  FaMoneyBillWave,
  FaMapMarkedAlt,
  FaEdit,
  FaFileAlt,
} from "react-icons/fa";
import { MdFeedback } from "react-icons/md";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { FaArrowLeft } from "react-icons/fa6";
import { PiInvoiceLight } from "react-icons/pi";
import { FaHouseUser } from "react-icons/fa";
import { Outlet, useParams } from "react-router-dom";
import {
  editServiceCenterApi,
  getServiceCenterDetailsApi,
} from "../../services/ServiceApi";
import { formatToNumber } from "../../utilities";
import { Spinner } from "react-bootstrap";
import EditServiceCenterModal from "./ServiceCenterEditModal";
import { Link, NavLink } from "react-router-dom";
import { CustomTooltip } from "../../components/CustomTooltip";
const ServiceCenterDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [editModal, setEditModal] = useState(false);
  const [editPrefixModal, setEditPrefixModal] = useState(false);
  const [preifxEditLoading, setPrefixEditLoading] = useState(false);
  const [form, setForm] = useState({
    prefix: "",
  });
  const [formError, setFormError] = useState({});

  const handleToggleEditModal = () => {
    setEditModal(!editModal);
  };
  const handleToggleEditPrefix = () => {
    if (!editPrefixModal) {
      setForm({ prefix: data?.invoice_prefix || "" });
    } else {
      setForm({
        prefix: "",
      });
      setFormError({});
    }
    setEditPrefixModal(!editPrefixModal);
  };
  const getData = () => {
    setLoading(true);
    getServiceCenterDetailsApi(id)
      .then((res) => {
        setError("");
        setData(res?.data?.results || null);
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  const handleAfterEditModal = () => {
    handleToggleEditModal();
    getData();
  };

  const tabs = [
    {
      name: "Bills History",
      icons: <FaFileAlt className="me-1" />,
      path: `/service-center/${id}`,
    },
    {
      name: "Users",
      icons: <FaHouseUser className="me-1" />,
      path: `/service-center/${id}/users`,
    },
  ];

  const handleUpdatePrefix = () => {
    const error = {};
    if (!form?.prefix) {
      error.prefix = "Required Field";
    }
    setFormError(error);
    if (Object.entries(error).length == 0) {
      setPrefixEditLoading(true);
      editServiceCenterApi(data?.id || "", {
        invoice_prefix: form?.prefix || "",
      })
        .then(() => {
          toast.success("Prefix Updated Successfully");
          handleToggleEditPrefix();
          getData();
        })
        .catch((err) => {
          toast.error(
            err?.response?.data?.message ||
              err?.response?.data?.error ||
              "Try again later"
          );
        })
        .finally(() => setPrefixEditLoading(false));
    }
  };
  if (loading) {
    return (
      <div className="text-center mt-5">
        <Spinner animation="border" />
      </div>
    );
  }

  if (error) {
    return <div className="text-center text-danger mt-5">{error}</div>;
  }
  return (
    <div className="card">
      <div className="container-fluid">
        <div className="row">
          <div className="col-md-4 p-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div className="d-flex gap-1">
                <Link
                  to="/service-center"
                  className="btn btn-outline-light rounded-2 p-2 align-self-center"
                >
                  <FaArrowLeft className="text-dark" />
                </Link>
                <div className="d-flex flex-column">
                  <h5 className="fw-bold mb-0">{data?.name || "-"}</h5>
                  <span
                    className="text-dark fw-medium"
                    style={{ fontSize: "0.75rem" }}
                  >
                    Professional Auto Care Service
                  </span>
                </div>
              </div>
              <button
                className="btn btn-outline-primary px-2 py-1"
                onClick={handleToggleEditModal}
              >
                <FaEdit className="me-1" /> Edit
              </button>
            </div>

            <div className="px-2 mb-1">
              <a
                href={data?.google_map_link || "#"}
                className="d-flex align-items-start gap-2 mb-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FaMapMarkerAlt className="text-dark mt-1" size="15" />
                <p
                  className="small text-darker text-decoration-underline cursor-pointer"
                  style={{ fontSize: "0.8rem" }}
                >
                  {data?.address || "-"}
                </p>
              </a>
              <a
                href={data?.google_review_link || "#"}
                className="d-flex align-items-start gap-2 mb-2"
                target="_blank"
                rel="noopener noreferrer"
              >
                <MdFeedback className="text-dark mt-1" size="15" />
                <p
                  className="small text-darker text-decoration-underline cursor-pointer"
                  style={{ fontSize: "0.8rem" }}
                >
                  Google review Link
                </p>
              </a>
              <div className="d-flex align-items-center gap-2 mb-2">
                <FaPhoneAlt className="text-dark" size="15" />
                <span
                  className="small text-darker"
                  style={{ fontSize: "0.8rem" }}
                >
                  {data?.contact_number || "-"}
                </span>
              </div>

              <div className="d-flex align-items-center gap-2 mb-2">
                <FaEnvelope className="text-dark" size="15" />
                <span
                  className="small text-darker"
                  style={{ fontSize: "0.8rem" }}
                >
                  {data?.contact_email || "-"}
                </span>
              </div>
              <div className="d-flex align-items-center gap-2 mb-2">
                <PiInvoiceLight className="text-dark" size="15" />
                {/* <span className="text-darker fw-medium" style={{fontSize:'0.8rem'}}>Invoice Prefix</span> */}
                <CustomTooltip title="Invoice Prefix">
                  <span
                    className="badge text-bg-info-soft rounded-pill d-flex align-items-center cursor-pointer text-wrap"
                    style={{ fontSize: "0.8rem" }}
                    onClick={handleToggleEditPrefix}
                  >
                    {data?.invoice_prefix || "-"}
                    <FaEdit className="ms-1" />
                  </span>
                </CustomTooltip>
              </div>
              {/* <div className="d-flex align-items-center gap-2">
                <FaClock className="text-dark" size="15" />
                <span
                  className="small text-darker"
                  style={{ fontSize: "0.8rem" }}
                >
                  Mon-Fri: 8:00 AM - 6:00 PM
                </span>
              </div> */}
            </div>

            <div className="bg-lighter rounded-3 p-3 mb-3">
              <h5 className="mb-3">Financial Overview</h5>
              <div className="row g-2">
                <div className="col-6">
                  <div className="border rounded-3 p-2">
                    <div className="d-flex align-items-center gap-1 mb-1">
                      <FaDollarSign className="text-success" />
                      <small className="text-dark">Cash</small>
                    </div>
                    <strong className="text-darker">
                      {formatToNumber(data?.total_cash)}
                    </strong>
                  </div>
                </div>
                <div className="col-6">
                  <div className="border rounded-3 p-2">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaExclamationTriangle className="text-danger" />
                      <small className="text-dark">Bad Debt</small>
                    </div>
                    <strong className="text-darker">
                      {formatToNumber(data?.total_baddebt)}
                    </strong>
                  </div>
                </div>
                <div className="col-6">
                  <div className="border rounded-3 p-2">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaClipboardList className="text-primary" />
                      <small className="text-dark">Unpaid Adj.</small>
                    </div>
                    <strong className="text-darker">
                      {formatToNumber(data?.total_unpaid_adjusted)}
                    </strong>
                  </div>
                </div>
                <div className="col-6">
                  <div className="border rounded-3 p-2">
                    <div className="d-flex align-items-center gap-2 mb-1">
                      <FaMoneyBillWave className="text-secondary" />
                      <small className="text-dark">Petty Cash</small>
                    </div>
                    <strong className="text-darker">
                      {formatToNumber(data?.total_petty_cash)}
                    </strong>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-md-8 border-start p-0">
            <div className="border-bottom p-2">
              <ul className="custom-nav1 nav nav-pills">
                {tabs.map((tab) => (
                  <li className="nav-item" key={tab.path}>
                    <NavLink
                      to={tab.path}
                      end={true}
                      className={({ isActive }) =>
                        "nav-link rounded-pill" + (isActive ? " active" : "")
                      }
                    >
                      {tab.icons}
                      {tab.name}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <Outlet />
          </div>
        </div>
      </div>

      <EditServiceCenterModal
        visible={editModal}
        onClose={handleToggleEditModal}
        onAfterSubmit={handleAfterEditModal}
        data={data}
      />

      <Modal show={editPrefixModal} onHide={handleToggleEditPrefix}>
        <Modal.Header closeButton>
          <Modal.Title>Edit Prefix</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="p-2">
            <div className="mb-2">
              <label className="form-label text-dark">Invoice Prefix</label>
              <input
                type="text"
                name="prefix"
                className={`form-control ${
                  formError?.prefix ? "is-invalid" : ""
                }`}
                value={form.prefix}
                placeholder="DCW"
                onChange={(e) => {
                  const value = e.target.value || "";
                  setForm({ ...formError, prefix: value });
                  if (value) {
                    setFormError({ ...formError, prefix: "" });
                  }
                }}
              />
              {formError?.prefix && (
                <small className="text-danger">{formError.prefix}</small>
              )}
            </div>

            <code className="text-light">
              <strong>Note:</strong> All fields are required
            </code>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex justify-content-end gap-2 w-100">
            <button
              className="btn btn-outline-dark"
              disabled={preifxEditLoading}
              onClick={handleToggleEditPrefix}
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleUpdatePrefix}
              disabled={preifxEditLoading}
            >
              {preifxEditLoading && <Spinner animation="border" size="sm" />}{" "}
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ServiceCenterDetails;
